import {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

const VehicleContext = createContext();

export const VehicleProvider = ({
  children,
}) => {

  const [
    selectedVehicle,
    setSelectedVehicle,
  ] = useState(null);

  const [
    vehicleLoaded,
    setVehicleLoaded,
  ] = useState(false);

  // Load saved vehicle
  useEffect(() => {

    const saved =
      localStorage.getItem(
        "selectedVehicle"
      );

    if (saved) {

      setSelectedVehicle(
        JSON.parse(saved)
      );

    }

    setVehicleLoaded(true);

  }, []);

  // Save vehicle
  useEffect(() => {

    if (selectedVehicle) {

      localStorage.setItem(
        "selectedVehicle",
        JSON.stringify(selectedVehicle)
      );

    }

  }, [selectedVehicle]);

  return (
    <VehicleContext.Provider
      value={{
        selectedVehicle,
        setSelectedVehicle,
        vehicleLoaded,
      }}
    >
      {children}
    </VehicleContext.Provider>
  );
};

export const useVehicle = () =>
  useContext(VehicleContext);